export const AgGridLicenseKey =
  'CompanyName=Two Sigma Investments, LP,LicensedGroup=Two Sigma,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=110,LicensedProductionInstancesCount=2,AssetReference=AG-026340,ExpiryDate=11_May_2023_[v2]_MTY4Mzc1OTYwMDAwMA==d645592fc29d0b6f2bf610efff8f0736';
